import { render, staticRenderFns } from "./PaymentInfoBlock.vue?vue&type=template&id=e87173c4&scoped=true"
import script from "./PaymentInfoBlock.vue?vue&type=script&lang=js"
export * from "./PaymentInfoBlock.vue?vue&type=script&lang=js"
import style0 from "./PaymentInfoBlock.vue?vue&type=style&index=0&id=e87173c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87173c4",
  null
  
)

export default component.exports